<template>
	<layout-admin>
		<router-view></router-view>
	</layout-admin>
</template>

<script>
export default {
	name: 'page-home',
};
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue